module.exports = __webpack_public_path__ + "img/banner1.e65e3fc8.jpg";